// Notification targets API client (admin). Reusable outbound webhooks
// (Pushover / Slack / Discord / any HTTP). The secret is vaulted server-side and
// never returned — responses carry only a `hasSecret` boolean.
import { api } from './api.js';

export const listTargets   = () => api.get('/api/admin/notification-targets').then((r) => r.targets || []);
export const createTarget  = (t) => api.post('/api/admin/notification-targets', t);
export const updateTarget  = (id, t) => api.put(`/api/admin/notification-targets/${id}`, t);
export const deleteTarget  = (id) => api.delete(`/api/admin/notification-targets/${id}`);
export const testTarget    = (id) => api.post(`/api/admin/notification-targets/${id}/test`);
